export default "__VITE_ASSET__BxFP53ZN__"